import React, { Component } from "react";
import { Table, Pagination, Col, Row, Button, Select, Input } from "antd";
import moment from "moment";
import { strings } from "../../../helpers";

const { Option } = Select;
const { Search } = Input;
const searchOptions = {
  componentRestrictions: { country: "in" }
};

export default class StaffView extends Component {
  render() {
    const { details } = this.props;
    const columns = [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        align: "left"
      },

      {
        title: "Mobile Number",
        dataIndex: "phone_number",
        key: "phone_number",
        align: "left"
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        align: "left"
      }
    ];
    let source = [];
    if (details && details.metrics) {
      source = details.clinic_staff;
    }

    return (
      <div className="content-container">
        <div className="backgroundWhite">
          <Row type="flex" justify="space-between" align="middle">
            <Col span={5} className="heading-domain">
              Staff
            </Col>
          </Row>

          <div className="mt-20 kc-block white-bg round-borders-4x">
            <Table
              //onRowClick={record => navigateToClinicDetails(record.id)}
              columns={columns}
              dataSource={source}
              pagination={false}
              rowKey="id"
            />
          </div>
        </div>
      </div>
    );
  }
}
